/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notefy-button[_ngcontent-%COMP%]{float:right;margin-right:3.6%}.mat-spinner-color[_ngcontent-%COMP%]  circle{stroke:#219653!important}.spinner-container[_ngcontent-%COMP%]{width:30px;float:right;margin-left:5px;margin-top:3px}"];
export { styles as styles };
